import { ReactElement } from 'react';
import { useTranslation } from '@jobcost-monorepo/i18n';

const InvoiceFormTitle = (): ReactElement => {
  const { t } = useTranslation('timesheets');

  return (
    <div>
      <p className="text-pink text-2xl">{t(`invoice.title`)}</p>
    </div>
  );
};

export default InvoiceFormTitle;
